import { ReferralEvent as e } from "./ReferralEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/referral/ReferralEventPayloads.ts
var n = t.object({ code: t.string() }), r = t.object({ context: t.enum(["signup", "landing"]) }), i = t.object({ matched: t.boolean() }), a = {
	[e.LinkLanded]: n,
	[e.CodeEntered]: r,
	[e.AppResolveMatched]: i
};
//#endregion
export { a as ReferralEventSchemas };
